<article class="property-card" (click)="select.emit(vm.propertyId)">
    <div class="property-card__media">
        <img *ngIf="vm.image; else placeholder" [src]="vm.image" [alt]="vm.typeLabel"
             class="property-card__img"/>
        <ng-template #placeholder>
            <div class="property-card__img property-card__img--placeholder"></div>
        </ng-template>

        <span *ngIf="vm.badge" class="property-card__badge" [ngClass]="vm.badge.colorClass">
            {{ vm.badge.label }}
        </span>
    </div>

    <div class="property-card__body">
        <div class="flex align-items-center justify-content-between">
            <span class="property-card__type">
                <img *ngIf="vm.typeIcon" [src]="vm.typeIcon" alt="" class="property-card__type-icon"/>
                <i *ngIf="!vm.typeIcon" class="pi pi-home"></i>
                {{ vm.typeLabel }}
            </span>
            <span *ngIf="vm.rating != null" class="property-card__rating">
                <i class="pi pi-star-fill"></i> {{ vm.rating | number: '1.1-1' }}
            </span>
        </div>

        <p class="property-card__location">{{ vm.location }}</p>
        <p class="property-card__price">{{ vm.price }}</p>

        <div class="property-card__metrics">
            <span class="property-card__metric">
                <img src="assets/layout/images/icons/metro.png" alt="Superficie"/> {{ vm.surface || '—' }}
            </span>
            <span class="property-card__metric">
                <img src="assets/layout/images/icons/bethroom.png" alt="Habitaciones"/> {{ vm.rooms ?? '—' }}
            </span>
            <span class="property-card__metric">
                <img src="assets/layout/images/icons/bathroom.png" alt="Baños"/> {{ vm.baths ?? '—' }}
            </span>
        </div>
    </div>
</article>
